/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_Overage_Off_DescInputs */



/**
* | output |
* | --- |
* | "When pool is empty, users fall back to oneAI Standard (free in the app); requests through an API key or the Microsoft Teams bot are refused" |
*
* @param {Usage_Tab_Overage_Off_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_overage_off_desc = /** @type {((inputs?: Usage_Tab_Overage_Off_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Overage_Off_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn der Pool leer ist, wechseln Nutzer zu oneAI Standard (in der App kostenlos); Anfragen über einen API-Schlüssel oder den Microsoft-Teams-Bot werden abgelehnt")
	return /** @type {LocalizedString} */ ("When pool is empty, users fall back to oneAI Standard (free in the app); requests through an API key or the Microsoft Teams bot are refused")
});